import { isAxiosError } from 'axios';

export const getDropClassErrorMessage = (error: unknown): string => {
  if (!isAxiosError(error)) {
    return 'Failed to drop class';
  }

  const responseData = error.response?.data;

  if (typeof responseData === 'string' && responseData.trim().length > 0) {
    return responseData;
  }

  if (responseData && typeof responseData === 'object') {
    const apiError = responseData.error;

    if (typeof apiError === 'string' && apiError.trim().length > 0) {
      return apiError;
    }

    if (
      apiError &&
      typeof apiError === 'object' &&
      'message' in apiError &&
      typeof apiError.message === 'string' &&
      apiError.message.trim().length > 0
    ) {
      return apiError.message;
    }

    const topLevelMessage = responseData.message;
    if (
      typeof topLevelMessage === 'string' &&
      topLevelMessage.trim().length > 0
    ) {
      return topLevelMessage;
    }
  }

  return 'Failed to drop class';
};
